import React from "react"
import { Box, Flex, Stack, Text } from "../../../vanilla"
import { useBasketStore, useOrderStore } from "../../../store/hooks/useStore"
import { PaymentMethod, PaypalVaultedPaymentMethod } from "./payment-method"
import { HostedFieldsAccountDetails } from "braintree-web/modules/hosted-fields"
import { PayPalAccountDetails } from "braintree-web/modules/paypal"
import useCustomSitePreference from "../../../hooks/forms/useCustomSitePreference"
import { braintreeInputStyle } from "../../../components/braintree/styles.css"
import { CheckoutButton } from "./checkout-button"
import { PaymentMethodButton } from "./payment-method-button"
import { SavedPaymentMethodAccordionProps } from "../../../types/checkout"
import { useCheckoutState } from "../../../contexts"

export const SavedPaymentMethodAccordion = (props: SavedPaymentMethodAccordionProps) => {
    const {
        card,
        selectedPayment,
        setSelectedPayment,
        submitOrderProcess,
        braintreeFormIsValid,
        hostedFieldsErrors,
        isTopUp
    } = props
    const { bonusCardStatus } = useBasketStore()
    const { isPaymentRefunding, editMode } = useOrderStore()
    const { billingAddressFormValid } = useCheckoutState()
    const savedPayPalPaymentAllowed = useCustomSitePreference('BRAINTREE_savedPaypalCheckoutEnabled', false)
    const vaultedFlow = useCustomSitePreference('BRAINTREE_PAYPAL_VAULTFLOW', false)
    const isSelected = selectedPayment?.split('_')[1] === card.nonce
    const isPayPalFlow = card?.type === 'PayPalAccount' && vaultedFlow

    if (
        !card?.details ||
        !card.nonce ||
        (card?.type === 'PayPalAccount' && !savedPayPalPaymentAllowed)
    )
        return null

    const { cardType, lastFour, expirationMonth, expirationYear } =
        card.details as HostedFieldsAccountDetails

    return (
        <Box
            border="1px"
            borderRadius="base"
            borderColor={isSelected ? 'accent3' : 'gray200'}
            borderTop={bonusCardStatus?.hidePayment || isPaymentRefunding ? '0px' : '1px'}
            paddingX="12px"
            paddingY="4px"
            key={card.nonce}
        >
            {isPayPalFlow ?
                <PaypalVaultedPaymentMethod
                    checked={isSelected}
                    email={(card?.details as PayPalAccountDetails).email ?? ''}
                    onClick={() => {
                        setSelectedPayment(`saved_${card.nonce}`)
                    }}
                /> :
                <>
                    <PaymentMethod
                        method={`${cardType} ending in ${lastFour}`}
                        type={cardType}
                        checked={isSelected}
                        onClick={() => {
                            setSelectedPayment(`saved_${card.nonce}`)
                        }}
                    />
                    <Stack
                        gap="12px"
                        display={isSelected ? 'block' : 'none'}
                        borderTop="1px"
                        borderColor="border1"
                        marginTop="4px"
                        paddingY="16px"
                        paddingX="24px"
                    >
                        <Stack width="140px">
                            <Text
                                variant="unstyled"
                                fontSize="sm"
                                lineHeight="none"
                                style={{
                                    width: 'fit-content',
                                    position: 'relative',
                                    top: '15px',
                                    left: '5px',
                                    background: 'linear-gradient(#fff,#fff 25%,#fafafa)',
                                    paddingLeft: '4px',
                                    paddingRight: '8px',
                                }}
                            >
                                Expiry Date
                            </Text>
                            <Box className={braintreeInputStyle}>
                                <Text
                                    variant="text3"
                                    paddingX="8px"
                                    paddingY="8px"
                                >
                                    {`${expirationMonth}/${expirationYear.slice(2)}`}
                                </Text>
                            </Box>
                        </Stack>
                    </Stack>
                </>
            }
            <Box
                padding="24px"
                display={isSelected ? 'block' : 'none'}
            >
                <Flex justifyContent="space-between">
                    <Stack width={['full', '300px']}>
                        {!isPayPalFlow ? (
                            <CheckoutButton
                                submitOrderProcess={submitOrderProcess}
                                isEditModeEnabled={editMode}
                                billingAddressFormValid={billingAddressFormValid}
                                isPaymentRefunding={isPaymentRefunding}
                                braintreeFormIsValid={braintreeFormIsValid}
                                bonusCardStatus={bonusCardStatus}
                                hostedFieldsErrors={hostedFieldsErrors}
                                isTopUp={isTopUp}
                            />
                        ) : (
                            <PaymentMethodButton isLoading={true} containerId={`PayPal-container-${1}`} backgroundColor={'black'} />
                        )}
                    </Stack>
                </Flex>
            </Box>
        </Box>
    )
}